module.exports = __webpack_public_path__ + "static/media/tip.1a334146.png";